import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { SkeletonLoader } from '@/components/common/StateViews';
import { useAuth } from '@/hooks/useAuth';

export function RequireAuth({ children }: PropsWithChildren) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Render nothing decisive while the stored token is still being validated.
  // Redirecting here would bounce a legitimately signed-in user to /login on
  // every hard refresh.
  if (isLoading) {
    return (
      <div className="p-8">
        <SkeletonLoader rows={5} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
